// src/analytics/ga.ts
import ReactGA from 'react-ga4';

// Replace with your actual Measurement ID G-FJMKHPS7EB
const MEASUREMENT_ID = 'G-FJMKHPS7EB'; 

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = (
  eventName,
  params = {}
) => {
  ReactGA.event(eventName, params);
};
